@file:OptIn(ExperimentalMaterial3Api::class)

package us.laantech.laanmanage.feature.store.pos.ui

import androidx.compose.foundation.layout.*
import androidx.compose.foundation.lazy.grid.GridCells
import androidx.compose.foundation.lazy.grid.LazyVerticalGrid
import androidx.compose.material3.*
import androidx.compose.runtime.*
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.luminance
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import androidx.lifecycle.compose.collectAsStateWithLifecycle
import androidx.lifecycle.viewmodel.compose.viewModel
import androidx.lifecycle.viewmodel.initializer
import androidx.lifecycle.viewmodel.viewModelFactory
import us.laantech.common.dto.PosConfigDTO
import us.laantech.common.ui.DropdownMenu

@Composable
fun PosEditorView(
    viewModel: PosEditorViewModel = viewModel(
        factory = viewModelFactory {
            initializer { PosEditorViewModel() }
        }
    )
) {

    val uiState by viewModel.uiState.collectAsStateWithLifecycle()
    LaunchedEffect(Unit) {
        viewModel.loadBranches()
        viewModel.loadPosConfigs()
    }

    Column(
        modifier = Modifier
            .fillMaxSize()
            .padding(16.dp)
    ) {
        Text("Touchscreen Configuration")

        Row(Modifier.fillMaxWidth(), horizontalArrangement = Arrangement.spacedBy(8.dp)) {

            DropdownMenu(
                label = "Select Store",
                items = uiState.branches,
                selectedItem = uiState.selectedBranch,
                itemLabel = { it.branchName ?: "Unnamed Store" },
                onItemSelected = { it?.let { branch -> viewModel.selectBranch(branch) } },
                modifier = Modifier.weight(1f),
                noneLabel = "All Stores"
            )

            // Select pos button config menu
            DropdownMenu(
                label = "Select POS Config",
                items = uiState.posConfigs.filter {
                    uiState.selectedBranch?.uuid == it.branchUuid
                },
                selectedItem = uiState.selectedPosConfig,
                itemLabel = { it.hardwareIdentifier },
                onItemSelected = { it?.let { config -> viewModel.selectPosConfig(config) } },
                modifier = Modifier.weight(1f),
            )
        }

        ButtonConfigurationView(viewModel)

        if (uiState.selectedPosConfig != null) {
            Button({viewModel.savePosConfig()},
                modifier = Modifier.fillMaxWidth(),
                colors = ButtonDefaults.buttonColors(containerColor = Color.Black, contentColor = Color.White)
            ) { Text("Save Button Configuration") }
        }

        Spacer(modifier = Modifier.height(16.dp))
        Text("Receipt Configuration")

    }

}

@Composable
fun ButtonConfigurationView(viewModel: PosEditorViewModel) {

    val uiState by viewModel.uiState.collectAsStateWithLifecycle()

    val buttonSpacedBy = 8.dp

    val buttonsPerRow = 7

    // Touchscreen Configuration


    // TODO



    if (uiState.showButtonConfigModal) {
        ButtonConfigurationModal(viewModel)
    }
}


@Composable
fun ReceiptConfigurationView(uiState: PosEditorUiState, viewModel: PosEditorViewModel) {

}